import { jsxs as f, Fragment as e, jsx as r } from "react/jsx-runtime";
import n from "lodash/get";
import { useBusRentalContext as _ } from "../BusRental.context.js";
import B from "../components/FAQ/FAQ.js";
import h from "../components/PickupLocation/PickupLocation.js";
import x from "../components/OurRoutes/OurRoutes.js";
import R from "../components/BusCollection/BusCollection.js";
import b from "../components/OurDrivers/OurDrivers.js";
import y from "../components/Testimonial/Testimonial.js";
const F = {
  our_locations: {
    comp: (o, t) => /* @__PURE__ */ r(h, { data: o }, t)
  },
  our_routes: {
    comp: (o, t) => /* @__PURE__ */ r(x, { data: o }, t)
  },
  our_bus_collections: {
    comp: (o, t) => /* @__PURE__ */ r(R, { data: o }, t)
  },
  our_drivers: {
    comp: (o, t) => /* @__PURE__ */ r(b, { data: o }, t)
  },
  our_customers: {
    comp: (o, t) => /* @__PURE__ */ r(y, { data: o }, t)
  }
}, K = () => {
  const { sections: o, faqs: t } = _();
  return /* @__PURE__ */ f(e, { children: [
    (() => /* @__PURE__ */ r(e, { children: o && o.map((i, u) => {
      const c = n(i, "mappingKey.uiKey", ""), s = n(F, `${c}`, null), m = n(i, "heading", ""), p = n(i, "subHeading", ""), a = n(i, "list", []), l = n(i, "img", {}), d = {
        heading: m,
        subHeading: p,
        list: a,
        img: l
      };
      if (s) {
        const g = s.comp;
        return g(d, u);
      }
      return null;
    }) }))(),
    /* @__PURE__ */ r(B, { listData: t })
  ] });
}, k = K;
export {
  k as default
};
